import React, {
  useState,
  useEffect,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { Grid } from '@material-ui/core';
import { getStatuses } from '@pingum/app-state-management/status/actions';

import Page from '../../widgets/Page';
import EventPageDialog from '../DashboardPage/dialogs/EventPageDialog';
import MyAssignmentsCard from './components/MyAssignmentsCard';
import PastDueEventsCard from './components/PastDueEventsCard';
import RecentOrganizationActivityCard from './components/RecentOrganizationActivityCard';
import SummaryCard from './components/SummaryCard';

export const HomePageComponent = () => {
  const dispatch = useDispatch();

  const [selectedEventId, setSelectedEventId] = useState(null);

  const {
    status: { statuses },
    event: { overdueEventsPageable = [] } = {},
    userEvents: { userAssignedPageable },
  } = useSelector((state) => state);

  useEffect(() => {
    if (statuses.length === 0) {
      // load statuses if not already in redux
      dispatch(getStatuses(false));
    }
  }, []);

  const handleEventClick = (eventId) => {
    setSelectedEventId(eventId);
  };

  return (
    <Page title="Home">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}>
          <SummaryCard
            value={userAssignedPageable.totalElements}
            label={
              userAssignedPageable.totalElements === 1
                ? 'Assignment'
                : 'Assignments'
            }
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <SummaryCard
            value={overdueEventsPageable.totalElements}
            label={
              overdueEventsPageable.totalElements === 1
                ? 'Past due event'
                : 'Past due events'
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={12}>
              <MyAssignmentsCard onEventClick={handleEventClick} statuses={statuses} />
            </Grid>
            <Grid item xs={12} sm={6} md={12}>
              <PastDueEventsCard onEventClick={handleEventClick} statuses={statuses} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={8}>
          <RecentOrganizationActivityCard onEventClick={handleEventClick} statuses={statuses} />
        </Grid>
      </Grid>

      <EventPageDialog
        open={!!selectedEventId}
        handleClose={() => { setSelectedEventId(null); }}
        eventId={selectedEventId}
      />
    </Page>
  );
};

export default HomePageComponent;
